export default "__VITE_ASSET__c5lgO6Qm__"